import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const SubContractorPeriod = () => {
  return (
    <SettingsMetaData propertyName={"conPeriod_Supplier"} viewPropertyName={"Sub-COntractor Periods"} />

  )
}

export default SubContractorPeriod